import React from 'react';
import ResumeHeader from '../components/ResumeHeader';
import ExperienceItem from '../components/ExperienceItem';
import ContactLinks from '../components/ContactLinks';
import SectionNav from '../components/SectionNav';
import {
    PROFILE,
    EXPERIENCES,
    TOTAL_EXPERIENCE_YEARS,
    EDUCATION,
    SKILLS,
    LANGUAGES,
    HOBBIES,
} from '../data/resume';
import styles from './Resume.module.scss';

const SECTIONS = [
    { id: 'about', label: 'About' },
    { id: 'experience', label: 'Experience' },
    { id: 'education', label: 'Education' },
    { id: 'skills', label: 'Skills' },
    { id: 'languages', label: 'Languages' },
    { id: 'hobbies', label: 'Hobbies' },
];

function Resume() {
    return (
        <main className={styles.resume}>
            <SectionNav sections={SECTIONS} />

            <ResumeHeader />

            <div className={styles.container}>
                {/* About Section */}
                <section id="about" className={styles.section}>
                    <h2 className={styles.sectionTitle}>About Me</h2>
                    <p className={styles.about}>
                        Hi! I'm {PROFILE.firstName}, a software engineer specializing in game development using Unity.
                        I have {TOTAL_EXPERIENCE_YEARS} of commercial development experience. In game development I've worked
                        across multiple genres — Midcore, Casual and Hyper-Casual — and shipped to Android,
                        Desktop and WebGL. I love what I do.
                    </p>
                </section>

                {/* Experience Section */}
                <section id="experience" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Work Experience</h2>
                    <div className={styles.experienceList}>
                        {EXPERIENCES.map((exp, idx) => (
                            <ExperienceItem key={idx} {...exp} />
                        ))}
                    </div>
                </section>

                {/* Education Section */}
                <section id="education" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Education</h2>
                    {EDUCATION.map((edu, idx) => (
                        <div key={idx} className={styles.educationItem}>
                            <h4>{edu.school}</h4>
                            <p className={styles.degree}>{edu.degree} • {edu.year}</p>
                            <p className={styles.field}>{edu.field}</p>
                        </div>
                    ))}
                </section>

                {/* Skills Section */}
                <section id="skills" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Technical Skills</h2>
                    <div className={styles.skillsGrid}>
                        {SKILLS.map((skill, idx) => (
                            <span key={idx} className={styles.skillTag}>{skill}</span>
                        ))}
                    </div>
                </section>

                {/* Languages Section */}
                <section id="languages" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Languages</h2>
                    <ul className={styles.languagesList}>
                        {LANGUAGES.map((lang, idx) => (
                            <li key={idx}>
                                <span className={styles.langName}>{lang.name}</span>
                                <span className={styles.langLevel}>{lang.level}</span>
                            </li>
                        ))}
                    </ul>
                </section>

                {/* Hobbies Section */}
                <section id="hobbies" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Hobbies</h2>
                    <div className={styles.hobbiesGrid}>
                        {HOBBIES.map((hobby, idx) => (
                            <span key={idx} className={styles.hobbyTag}>
                                <span className={styles.hobbyEmoji}>{hobby.emoji}</span>
                                {hobby.name}
                            </span>
                        ))}
                    </div>
                </section>

                {/* Contacts — дубль шапки, чтобы связаться можно было в конце чтения */}
                <section className={styles.contactsFooter}>
                    <h2 className={styles.contactsFooterTitle}>Get in touch</h2>
                    <ContactLinks />
                </section>
            </div>
        </main>
    );
}

export default Resume;
